import React, { useEffect, useState } from 'react'
import { ClientsDashboardProfileView } from '../../views'
import { useParams } from 'react-router-dom'
import { ClientsService, LocalStorageService } from '../../../services';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';

const url = process.env.REACT_APP_ETICKET_API;
const localStorageService = new LocalStorageService();
const clientsService = new ClientsService(url)

// La sesión se lee en cada handler (no en el scope del módulo): este módulo se
// importa de forma eager desde routes/index.js, antes de que exista el login.
const getToken = () => localStorageService.getLocalStorageItem("token")?.idToken

function ClientsDashboardProfileAction() {
    const { userId } = useParams()
    const history = useHistory();
    const location = useLocation();

    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState({
        dashboardData1: null,
        dashboardData2: null
    })

    const [dates, setDates] = useState({
        startDate: moment().subtract(1, 'year').toDate(),
        endDate: moment().toDate()
    })

    const handleDateChange = (event, field) => {
        setDates({ ...dates, [field]: event.target.value });
    }

    const onLoad = async (firstRender) => {
        //toggleError(null)
        setIsLoading(true)
        try {
            let startDate = dates.startDate
            let endDate = dates.endDate

            if (firstRender) {
                if (location.search) {
                    const searchParams = new URLSearchParams(location.search);
                    startDate = moment(searchParams.get('startDate')).toDate()
                    endDate = moment(searchParams.get('endDate')).toDate()
                    setDates({ startDate, endDate })
                }
            } else {
                const searchParams = new URLSearchParams();
                startDate = moment(dates.startDate).toDate()
                endDate = moment(dates.endDate).toDate()

                searchParams.append('startDate', moment(startDate).format('YYYY-MM-DD'));
                searchParams.append('endDate', moment(endDate).format('YYYY-MM-DD'));
                history.replace({ pathname: location.pathname, search: searchParams.toString() })
            }

            const token = getToken()
            const dashboardData1 = await clientsService.getClientsProfileDashboard(token, userId, startDate, endDate, 1)
            const dashboardData2 = await clientsService.getClientsProfileDashboard(token, userId, startDate, endDate, 2)
            setData({
                dashboardData1,
                dashboardData2
            })
            setIsLoading(false)
        } catch (error) {
            console.log(error)
        }
    }

    const handleBack = () => {
        history.goBack()
    }

    useEffect(() => {
        onLoad(true);
    }, [])

    return (
        <ClientsDashboardProfileView
            isLoading={isLoading}
            dashboardData1={data.dashboardData1}
            dashboardData2={data.dashboardData2}
            dates={dates}
            handleDateChange={handleDateChange}
            handleSearch={() => onLoad(false)}
            handleBack={handleBack}
        />
    )
}

export default ClientsDashboardProfileAction